import Cotizaciones from "../Cotizaciones"

export const VCotizaciones = () => {
    return <Cotizaciones />
}
export default VCotizaciones